import { FaEnvelope } from 'react-icons/fa6';
import { GiShatteredHeart, GiSonicShoes } from 'react-icons/gi';
import { CenteredSection } from '~/components/layouts/CenteredSection';
import InfoBox from '~/shared/components/info_boxes/InfoBox';
import HeroWithBackground from '~/shared/components/sections/HeroWithBackground';
import ContactForm from '~/shared/contact/ContactForm';
import { getLcn } from '~/utils/labeled-classnames';
import { publicStorageUrl } from '~/utils/paths';

export const bgUrl1 = publicStorageUrl('coaching/images/hero_bg/1.webp');

export default function Contact() {
  const lcn = getLcn({
    home: ''
  });

  return (
    <div className='styled flex flex-col gap-10'>


      <HeroWithBackground bgUrl={publicStorageUrl(`music/images/hero_bg/6.webp`)}>
        <CenteredSection>
          <div className='py-32 px-4'>
            <div className='flex  justify-center'>

              <div className='text-white flex flex-col gap-6 bg-black/60 p-9 rounded-lg w-full sm:w-3/4 md-w-2/3'>
                <div className='brand-font text-4xl'>
                  "A journey of a thousand miles begins with a single step."
                </div>
                <div className='text-xl text-right'>
                  - Lao Tzu
                </div>
              </div>
            </div>
          </div>
        </CenteredSection>
      </HeroWithBackground>

      <CenteredSection size='md'>
        <div className='flex flex-col gap-10'>
          <InfoBox type='info' icon={< FaEnvelope />}>
            <div>
              We offer phone consultations to explore how we can serve you. Reaching out is the first step towards the transformation you want to see!
            </div>
            <div>
              In the form below, tell us a bit about your project, what services you're looking for.
            </div>
          </InfoBox>

          <ContactForm />
        </div>
      </CenteredSection>
    </div >

  );
}; 